__turbopack_context__.v({
  "buttonsWrapper": "Evpihq_buttonsWrapper",
  "container": "Evpihq_container",
  "content": "Evpihq_content",
  "description": "Evpihq_description",
  "title": "Evpihq_title",
});
